<div class="jumbotron">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        @if (employee && leaveBalance) {
          <div class="card leave-section">
            <div class="card-header">
              Leave Balance
              @if (leavesMonths !== null) {
                <small class="ms-1">(since {{ leavesMonths }} months)</small>
              }
            </div>
            <div class="card-body">
              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  Annual Leaves
                  <span class="badge bg-primary">
                    {{ leaveBalance.ANNUAL ?? 0 }} / {{ leaveBalance.ANNUAL_LEFT ?? 0 }}
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  Sick Leaves
                  <span class="badge bg-primary">
                    {{ leaveBalance.SICK ?? 0 }} / {{ leaveBalance.SICK_LEFT ?? 0 }}
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  Personal Leaves
                  <span class="badge bg-primary">{{ leaveBalance.PERSONAL ?? 0 }}</span>
                </li>
              </ul>
            </div>
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <!-- <div class="card">
        <div class="card-header">
          My Status
        </div>
        <div class="card-body">

        </div>
      </div>
      <br> -->
      <div class="card">
        <div class="card-header">
          Actions
        </div>
        <div class="card-body">
          <li class="list-group-item">
            <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group">
              <button type="button" class="btn btn-secondary"
                (click)="changeP(content3, user)"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                height="16" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
                <path
                  d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z" />
                <path
                  d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z" />
              </svg> Change Password
              </button>
              @if (employee) {
                <button type="button" class="btn btn-primary btn-add ms-2" (click)="openCreateLeave(leaveModal)">
                  <span class="btn-icon" aria-hidden="true">+</span>
                  New Leave Request
                </button>
              }
            </div>
          </li>
        </div>
      </div>
    </div>
  </div>

@if (employee) {
  <div class="row mt-4">
    <div class="col-12">
      <div class="card leave-section">
        <div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
          <span>My Leave Requests</span>
          <div class="d-flex align-items-center gap-2">
            @if (myLeaves.length > 0) {
              <span class="badge rounded-pill bg-light text-dark">{{ myLeaves.length }} request(s)</span>
            }
            <button type="button" class="btn btn-light btn-sm" (click)="loadEmployeeLeaveData()">Refresh</button>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover leave-table mb-0">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">From</th>
                  <th scope="col">To</th>
                  <th scope="col" class="text-center">Days</th>
                  <th scope="col">Type</th>
                  <th scope="col">Notes</th>
                  <th scope="col" class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (myLeaves.length === 0) {
                  <tr>
                    <td colspan="7" class="empty-state">
                      <div class="empty-content">
                        <p class="mb-1 fw-semibold">No leave requests yet</p>
                        <p class="text-muted small mb-0">Submit your first request using the button above.</p>
                      </div>
                    </td>
                  </tr>
                }
                @for (leave of myLeaves; track leave.id; let i = $index) {
                  <tr>
                    <td class="text-muted">{{ i + 1 }}</td>
                    <td>{{ leave.from_date | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ leave.to_date | date: 'dd/MM/yyyy' }}</td>
                    <td class="text-center">
                      <span class="days-badge">{{ leave.dayDiff }}</span>
                    </td>
                    <td>
                      <span class="badge leave-badge {{ getLeaveTypeMeta(leave.leave_type).badge }}">
                        {{ getLeaveTypeMeta(leave.leave_type).label }}
                      </span>
                    </td>
                    <td class="notes-cell" [title]="leave.notes || ''">
                      {{ leave.notes || '—' }}
                    </td>
                    <td class="text-end">
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        (click)="openEditLeave(leaveModal, leave)"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
}
  </div>
</div>
<ng-template #content3 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Reset Password</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label" for="email">email</label>
      <input type="text" class="form-control" [(ngModel)]="user_password.email" id="email" disabled>
    </div>
    <div class="mb-3">
      <label class="form-label" for="password">New Password</label>
      <input type="password" class="form-control" [(ngModel)]="user_password.password" id="password"
        placeholder="add password">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="OnChangePassword(user_password.id)">Submit</button>
  </div>
</ng-template>

<ng-template #contentSlot let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">My Calender Slots</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label class="form-label">My Booked Slots</label>
          <div class="card">
            <div class="card-body table-wrapper">
              <table class="table">
                <tr>
                  <td>date</td>
                  <td colspan="2">time</td>
                  <td>Reason</td>
                </tr>
                @for (slot of slots; track slot) {
                  <tr>
                    <td>{{slot.date_time | date:'dd/MM/yyyy'}}</td>
                    <td>{{slot.date_time | date:'hh:mm a'}}</td>
                    <td>{{slot.date_time_to | date:'hh:mm a'}}</td>
                    <td>{{slot.reason}}</td>
                  </tr>
                }
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="date" class="form-label">Date</label>
          <input type="datetime-local" class="form-control" id="date" [(ngModel)]="slot.date">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="period" class="form-label">Period</label>
          <input type="number" class="form-control" [(ngModel)]="slot.period" id="period">
        </div>
      </div>
      <div class="mb-3">
        <label for="reason" class="form-label">Booked Reason</label>
        <textarea class="form-control" [(ngModel)]="slot.reason" id="reason" rows="2" cols="50"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="createSlot()">Add</button>
  </div>
</ng-template>

<ng-template #leaveModal let-modal>
  <div class="modal-header border-0 pb-0">
    <div>
      <h4 class="modal-title mb-1">
        {{ modalMode === 'edit' ? 'Edit Leave Request' : 'New Leave Request' }}
      </h4>
      <p class="text-muted small mb-0">Fill in the details below</p>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body pt-3">
    <div class="row g-3">
      <div class="col-12">
        <label class="form-label">Employee</label>
        <input type="text" class="form-control" [value]="employee?.name" disabled>
      </div>

      <div class="col-md-6">
        <label for="from_date" class="form-label">From <span class="text-danger">*</span></label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="leaveForm.from_date"
          id="from_date"
          required
        />
      </div>
      <div class="col-md-6">
        <label for="to_date" class="form-label">To <span class="text-danger">*</span></label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="leaveForm.to_date"
          id="to_date"
          [min]="leaveForm.from_date"
          required
        />
      </div>

      @if (previewDays !== null) {
        <div class="col-12">
          <div
            class="duration-preview"
            [class.duration-preview--invalid]="previewDays <= 0"
          >
            @if (previewDays > 0) {
              <span>Duration: <strong>{{ previewDays }}</strong> day(s)</span>
            } @else {
              <span>End date must be on or after the start date.</span>
            }
          </div>
        </div>
      }

      <div class="col-12">
        <label for="leave_type" class="form-label">Leave type <span class="text-danger">*</span></label>
        <select class="form-select" [(ngModel)]="leaveForm.leave_type" id="leave_type" required>
          @for (type of leaveTypes; track type.value) {
            <option [value]="type.value">{{ type.label }}</option>
          }
        </select>
      </div>

      <div class="col-12">
        <label for="notes" class="form-label">Notes</label>
        <textarea
          class="form-control"
          [(ngModel)]="leaveForm.notes"
          id="notes"
          rows="3"
          placeholder="Optional reason or comments..."
        ></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-0">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!isLeaveFormValid || submitting"
      (click)="saveLeave()"
    >
      @if (submitting) {
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      }
      {{ modalMode === 'edit' ? 'Save changes' : 'Submit request' }}
    </button>
  </div>
</ng-template>